export default "__VITE_ASSET__m8K$k82g__"